<template>
  <div class="header-menu">
    <b-nav class="header-menu header-menu__links">
      <b-nav-item v-if="userType === 'company'" :to="{ path: '/get-started' }" class="menu-button">
        <div class="header-menu-btn">Get Started</div>
      </b-nav-item>
      <b-nav-item :to="{ path: '/integrations' }" class="menu-button">
        <div class="header-menu-btn">Apps</div>
      </b-nav-item>
      <b-nav-item v-if="userType === 'hacker'" :to="{ path: '/scans' }" class="menu-button">
        <div class="header-menu-btn">Single Scans</div>
      </b-nav-item>
      <b-nav-item
        :to="{
          path: `${
            userType && userType === 'company' ? '/settings/profile-info' : '/settings/scan-history'
          }`,
        }"
        class="menu-button"
      >
        <div class="header-menu-btn">Settings</div>
      </b-nav-item>
    </b-nav>
    <div v-if="userType === 'hacker'">
      <b-nav-item
        :to="isMaintenanceMode ? null : { path: '/scan/upload' }"
        @click="isMaintenanceMode && $event.preventDefault()"
      >
        <button
          class="login-button"
          :class="{ 'login-button--disabled': isMaintenanceMode }"
          :disabled="isMaintenanceMode"
        >
          New Scan
        </button>
      </b-nav-item>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { MAINTENANCE_MODE_ENABLED } from '@/utils/constants/common';

export default {
  computed: {
    ...mapGetters({
      userType: 'user/userType',
    }),
    isMaintenanceMode() {
      return MAINTENANCE_MODE_ENABLED;
    },
  },
};
</script>
<style lang="scss">
@import '../../assets/css/fonts';

.header-menu-btn {
  &:hover {
    text-decoration: underline;
  }
}

.header-menu {
  display: flex;

  &__links {
    margin-top: -15px;
  }

  .nav-link {
    @include Aspekta-font(600, 14px, normal, #0c0d0e);
    letter-spacing: 0.42px;
  }
}

.nav-item {
  list-style: none;
  user-select: none;
}

.login-button {
  @include Aspekta-font(600, 17px, normal, #ff7a08);
  display: flex;
  justify-content: center;
  width: 160px;
  border: 2px solid #ffd2ab;
  border-radius: 8px;
  margin-left: 10px;
  padding: 16px 20px;
  outline: none;
  background: transparent;

  &--disabled,
  &:disabled {
    color: #9ca3af !important;
    border: 2px solid #e5e7eb !important;
    background: #e5e7eb !important;
    cursor: not-allowed !important;
    pointer-events: none !important;
    opacity: 1 !important;
  }
}

.login-button a.nav-link {
  color: #ff7a08;
}

div.header-menu-btn {
  margin-bottom: 0 !important;
}

@media (max-width: 768px) {
  .header-menu {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center !important;

    .nav-link {
      @include Aspekta-font(600, 24px, normal, #0c0d0e);
      margin-bottom: 26px;
    }
  }

  .header-menu-btn {
    margin-bottom: 40px !important;
    color: #242424;
  }

  .login-button {
    margin: 0 !important;
  }
}
</style>
